import Swiper, { Lazy, Navigation, Scrollbar } from 'swiper';
import 'swiper/css';

const selectors = {
  carousel: '[data-product-carousel]',
};

class ProductCarousel extends HTMLElement {
  constructor() {
    super();

    this.$carousels = [...this.querySelectorAll(selectors.carousel)];

    if (this.$carousels.length === 0) {
      return;
    }

    this.init();
  }

  init() {
    this.initCarousels();
  }

  initCarousels() {
    this.$carousels.forEach($carousel => {
      const $next = $carousel.parentNode.querySelector('.swiper-button-next');
      const $prev = $carousel.parentNode.querySelector('.swiper-button-prev');

      this.carousel = new Swiper($carousel, {
        modules: [Lazy, Navigation, Scrollbar],
        freeMode: true,
        slidesPerView: 2,
        spaceBetween: 10,
        watchOverflow: true,
        lazy: true,
        navigation: {
          nextEl: $next,
          prevEl: $prev,
        },
        scrollbar: {
          el: '.slider-scrollbar',
          draggable: true,
          hide: false,
          snapOnRelease: false,
          dragSize: 100,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    });
  }
}

customElements.define('product-carousel', ProductCarousel);
